import React, { useState, useEffect } from 'react'
import Typography from '../common/Typography'
import { Grid, Paper } from '@material-ui/core'
import { useStyles } from './styles'
import { useTrans } from '../../services/i18n'
import { ColoredLogoSvg } from '../svg/logos'
import { useApplication } from '../../services/application'
import packageJson from '../../../package.json'

const getDisplayAppVersion = (appVersion) => {
  if (!appVersion || appVersion === 'Unknown') {
    return appVersion
  }

  const releaseIndex = appVersion.indexOf('-release')

  if (releaseIndex === -1) {
    return packageJson.version
  }

  return `${packageJson.version}${appVersion.substring(releaseIndex)}`
}

const AuthLayout = ({ actions, children }) => {
  const classes = useStyles()
  const { trans } = useTrans()
  const application = useApplication()
  const [appVersion, setAppVersion] = useState('Unknown')

  useEffect(() => {
    async function getAppVersion() {
      try {
        const version = await application.rpcClient.call('healthCheck')
        setAppVersion(getDisplayAppVersion(version.version))
      } catch (error) {
        console.error('Unable to check app version', error)
      }
    }

    getAppVersion()
  }, [])

  return (
    <Grid container spacing={0} direction="row" className={classes.height}>
      <Grid item xs={12} className={classes.imageBlock}>
        <Paper className={classes.media}>
          <div className={classes.authHeader}>
            <div className={classes.logos}>
              <div style={{ width: 320, height: 45, overflow: 'hidden', position: 'relative', marginLeft: -60, marginTop: -8 }}>
                <img
                  src="/ADVANTAGE_FFFFF.png"
                  alt="Advantage"
                  style={{
                    position: 'absolute',
                    width: 320,
                    height: 'auto',
                    top: '50%',
                    transform: 'translateY(-50%)',
                  }}
                />
              </div>
            </div>
          </div>
          <div
            style={{
              background: 'white',
              width: 550,
              margin: '0 auto',
              borderRadius: '40px',
            }}
          >
            {children}
          </div>
          <div style={{ textAlign: 'center' }}>
            <Typography variant="body2" component="p">
              © {trans('copyright')} - {new Date().getFullYear()} US Federal Contractor Registration -
              All Rights Reserved.
            </Typography>
            <Typography variant="body2" component="p">
              App Version: {appVersion}
            </Typography>
          </div>
        </Paper>
      </Grid>
      <Grid className={classes.mobileHeader} item xs={12}>
        <ColoredLogoSvg />
        {false && <div>{actions}</div>}
      </Grid>
      <div item sm={12} xs={12} className={classes.content}>
        {children}
      </div>
      <div className={classes.mobileFooter}>
        <div style={{ textAlign: 'center' }}>
          <Typography variant="body2" component="p">
            © {trans('copyright')} - {new Date().getFullYear()} US Federal Contractor Registration -
            All Rights Reserved.
          </Typography>
          <Typography variant="body2" component="p">
            App Version: {appVersion}
          </Typography>
        </div>
      </div>
    </Grid>
  )
}

export default AuthLayout